/* eslint-disable import/prefer-default-export */
import moment from 'moment';

export function getRequestObj() {
  const request = {
    company_code: '',
    company_name: '',
    category: '',
    subcategory_1: '',
    subcategory_2: '',
    accounting_processors: [],
    attachment: [],
    payee_paygroup: '',
    payee_desc: '',
    payee_code: '',
    particulars: '',
    mode_of_payment: '',
    project_code: '',
    project_desc: '',
    cost_center_code: '',
    cost_center_desc: '',
    ref_no: '',
    date_payable: moment(),
    billing_period_from: moment(),
    billing_period_to: moment(),
    details: [],
    currency: 'PHP',
    total_amount: 0,
  };

  return request;
}
